import { doc, getDoc, updateDoc, addDoc, collection, getDocs, query, orderBy } from "firebase/firestore"
import { db } from "./config"
import { createNotification } from './notifications'

export const setMessageRead = async (msgId) => {
    try {
        // Reference to the specific user document
        const messagesRef = doc(db, "messages", msgId)
        const messageSnapshot = await getDoc(messagesRef)
        const messageData = messageSnapshot.data()

        await updateDoc(messagesRef, { ...messageData, state: "read" })
    } catch (e) {
        console.error("Error getting document: ", e)
    }
}

export const sendListingNotification = async ({ recipientId, listingTitle, action, reason = null, adminUserId }) => {
    try {
        console.log("=== SENDING LISTING NOTIFICATION ===")
        console.log("Recipient ID:", recipientId)
        console.log("Listing Title:", listingTitle)
        console.log("Action:", action)
        console.log("Reason:", reason)
        
        let notificationMessage = ""
        
        if (action === "approved") {
            notificationMessage = `You approved the listing "${listingTitle}" and it is now live on the marketplace.`
        } else if (action === "declined") {
            notificationMessage = `You declined the listing "${listingTitle}".${reason ? ` Reason: ${reason}` : ""}`
        }

        // Create notification for the admin only
        const notificationData = {
            adminUserId: adminUserId,
            title: `Listing ${action}`,
            message: notificationMessage,
            type: 'listing_action',
            listingAction: action,
            listingTitle: listingTitle,
            recipientId: recipientId, // Keep for reference
            reason: reason
        }
        
        await createNotification(notificationData)
        console.log(`Admin notification created for listing "${listingTitle}" - ${action}`)
    } catch (e) {
        console.error("Error sending listing notification: ", e)
        throw e
    }
}